import type { AudioPortfolioItemViewModel } from '../../ViewModel/AudioPortfolioItemViewModel.csharp';
import type { IPortfolioItemViewModel } from '../../ViewModel/IPortfolioItemViewModel.csharp';
import type { ImagePortfolioItemViewModel } from '../../ViewModel/ImagePortfolioItemViewModel.csharp';
import { PortfolioItemType } from '../../ViewModel/PortfolioItemType.csharp';
import type { VideoPortfolioItemViewModel } from '../../ViewModel/VideoPortfolioItemViewModel.csharp';
import type { PortfolioItemDetailsWithId } from '~/Features/StudyPage/Campus/Sections/StudyPortfolioSection/StudyPortfolioSection';

const isAudioItem = (item: IPortfolioItemViewModel): item is AudioPortfolioItemViewModel =>
    item.type === PortfolioItemType.Audio;

const isVideoItem = (item: IPortfolioItemViewModel): item is VideoPortfolioItemViewModel =>
    item.type === PortfolioItemType.Video;

const isImageItem = (item: IPortfolioItemViewModel): item is ImagePortfolioItemViewModel =>
    item.type === PortfolioItemType.Image;

export const mapToPortfolioItems = (items: IPortfolioItemViewModel[]): PortfolioItemDetailsWithId[] =>
    items.map(item => {
        if (isImageItem(item)) {
            return {
                type: 'image',
                id: item.id,
                title: item.title,
                caption: item.caption,
                image: item.image,
                link: item.link,
            };
        }

        if (isVideoItem(item)) {
            return {
                type: 'video',
                id: item.id,
                title: item.title,
                caption: item.caption,
                image: item.image,
                link: item.link,
            };
        }

        if (isAudioItem(item)) {
            return {
                type: 'audio',
                id: item.id,
                title: item.title,
                caption: item.caption,
                image: item.image,
                link: item.link,
            };
        }

        throw new Error(`Not supported item type: ${item.type}`);
    });
